const getElementTop = (element, extraSpacing = 16) =>
{
    if (element === null) {
        return false;
    }

    //let extraSpacing = 16;
    let rect = element.getBoundingClientRect();
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let position = rect.top + scrollTop;

    // Get header height
    let header = document.getElementById('header');
    if (header !== null && header.style.position === 'fixed') {
        let headerRect = header.getBoundingClientRect();
        position -= headerRect.height;
    }

    let htmlStyles = window.getComputedStyle(document.documentElement);

    // account for admin bar height
    let adminHeight = parseInt(htmlStyles.getPropertyValue('--wp-admin--admin-bar--height'));
    if (!isNaN(adminHeight)) {
        position -= adminHeight;
    }

    // let scrollPaddingTop = htmlStyles.getPropertyValue("scroll-padding-top");
    // if (scrollPaddingTop) {
    //     position -= parseInt(scrollPaddingTop.slice(0, -2));
    // }

    if (extraSpacing > 0 && position > extraSpacing) {
        position -= extraSpacing;
    }

    if (!isNaN(position) && position > 0) {
        position = parseInt(position);
    } else {
        position = false;
    }

    return position;
}

export default getElementTop;
